var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cs-button',_vm._b({attrs:{"min-width":_vm.width,"loading":_vm.busy,"text":_vm.textButton},on:{"click":function($event){$event.preventDefault();return _vm.submit()}}},'cs-button',_vm.requestProps,false),[_vm._v(" "+_vm._s(_vm.textButton)+" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }